import React from "react";
import { Table, Column, Cell } from "fixed-data-table-2";
import DataActions from "../../services/DataAccess/DataActions";
import { withRouter } from "react-router-dom";
import ModalService from "../../services/ModalService";
import moment from "moment";
import PropTypes from "prop-types";
import * as $ from "jquery";

import {
  Icon,
  FileViewerModal,
  LexButton,
  InlineTextArea,
  TableBase,
  SortHeaderCell,
  DataListWrapper,
  InlineEdit,
  Dimensions,
  AxoLocal,
} from "../../utilities/LexUtilities";

import { FormControl, FormGroup, InputGroup } from "react-bootstrap";

const defaultColumnDefs = {
  name: {
    width: 100,
    shown: true,
  },
  type: {
    width: 125,
    shown: true,
  },
  description: {
    width: 200,
    shown: true,
  },
  picture: {
    width: 125,
    shown: true,
  },
  creationDate: {
    width: 100,
    shown: true,
  },
  actions: {
    width: 90,
    shown: true,
  },
};

class ItemPriceTypesTable extends TableBase {
  static propTypes = {
    itemPriceTypes: PropTypes.array.isRequired,
  };

  constructor(props) {
    super(props);
    this.name = "ItemPriceTypesTable";
    this.defaultColumnDefs = defaultColumnDefs;

    this._defaultSortIndexes = this.generateDefaultSortIndexes(
      props.itemPriceTypes
    );
    let tableEntries = this.copyItems(props.itemPriceTypes);
    this.state = {
      tableEntries: tableEntries,
      columnDefs: this.retrieveColumnDefs(),
      minColWidths: {},
      maxColumnWidth: 250,
      sortedDataList: new DataListWrapper(
        this._defaultSortIndexes,
        tableEntries
      ),
      colSortDirs: {},
      searchText: "",
    };
  }

  copyItems = (entries) => {
    return entries.map((c) => Object.assign({}, c));
  };

  componentWillReceiveProps(nextProps) {
    let tableEntries = this.copyItems(nextProps.itemPriceTypes);
    let filteredEntries = this.getFilteredEntries(
      tableEntries,
      this.state.searchText
    );

    this.updateEntries(tableEntries, filteredEntries);
  }

  onSearch = (event) => {
    this.setState(
      {
        searchText: event.target.value,
      },
      () => {
        this.updateFilteredEntries();
      }
    );
  };

  updateFilteredEntries = () => {
    let { tableEntries } = this.state;

    var entries = this.getFilteredEntries(tableEntries, this.state.searchText);
    this._defaultSortIndexes = this.generateDefaultSortIndexes(entries);
    this.setState({
      sortedDataList: new DataListWrapper(this._defaultSortIndexes, entries),
    });
  };

  getFilteredEntries = (entries, searchText) => {
    if (!searchText && !this.state.showCurrency) {
      return entries;
    }
    let filteredEntries = entries;
    if (this.state.showCurrency) {
      filteredEntries = filteredEntries.filter(
        (entry) =>
          entry.currency.toLowerCase() === this.state.showCurrency.toLowerCase()
      );
    }
    return filteredEntries.filter((c) => {
      return c.description.toLowerCase().includes(searchText.toLowerCase());
    });
  };

  onChangePropertyValue = (id, propertyName, value) => {
    var { sortedDataList } = this.state;

    var index = sortedDataList._data.findIndex((c) => c.id === id);
    if (index === -1) {
      return;
    }

    var type = { ...sortedDataList._data[index] };
    type[propertyName] = value;
    var newList = new DataListWrapper(
      sortedDataList._indexMap,
      sortedDataList._data
    );
    var newArray = newList._data.slice();
    newArray[index] = type;
    newList._data = newArray;
    this.setState({ sortedDataList: newList }); //Optimistic updating

    DataActions.updateItemPriceType(type);
  };

  onDeletePrice = (id) => {
    var confirmMessage = (
      <div>
        <div>
          <AxoLocal
            entity="Enhedspris19"
            defaultValue="Dette vil slette typen permanent."
          />
        </div>
        <div>
          <AxoLocal
            entity="AdminTabView21"
            defaultValue="Er du sikker på at du ønsker at fortsætte?"
          />
        </div>
      </div>
    );
    ModalService.openConfirmModal(confirmMessage, (value) => {
      if (value) {
        DataActions.deleteItemPriceType(id);
      }
    });
  };

  onShowPicture = (picture) => {
    this.fileModal.open([picture]);
  };

  uploadPicture = (price) => {
    let newPrice = { ...price };
    $("#uploadImage").trigger("click");
    $("#uploadImage").on("change", function () {
      let file = this.files[0];
      if (!file.type.includes("image")) {
        return;
      }
      DataActions.uploadDocuments(this.files).then((response) => {
        if (response.ok) {
          response.json().then((addedFiles) => {
            newPrice.fileInfoModelId = addedFiles[0].id;
            DataActions.updateItemPriceType(newPrice);
          });
        }
      });
    });
  };

  render() {
    var { sortedDataList, colSortDirs, columnDefs } = this.state;
    const { containerHeight, containerWidth } = this.props;
    var tableWidth = containerWidth - 30;

    return (
      <div>
        <div
          className="flexbox-layout"
          style={{ paddingLeft: "25px", paddingRight: "25px" }}
        >
          <h4>
            <Icon glyph="icon-fontello-align-justify" />
            &nbsp;&nbsp;
            <AxoLocal entity="Enhedspris18" defaultValue="Typer" /> (
            {sortedDataList._data.length})
          </h4>
          <div style={{ maxWidth: "250px", paddingTop: "15px" }}>
            <FormGroup controlId="inputWithIcon">
              <InputGroup>
                <InputGroup.Addon>
                  <Icon glyph="icon-fontello-search" />
                </InputGroup.Addon>
                {/* Søg...  */}
                <AxoLocal
                  componentClass={FormControl}
                  type="text"
                  value={this.state.searchText}
                  onChange={this.onSearch}
                  componentAttribute="placeholder"
                  entity="ContactTableViewplaceholderonSearch"
                />
                <FormControl.Feedback>
                  <Icon glyph="icon-fontello-search" />
                </FormControl.Feedback>
              </InputGroup>
            </FormGroup>
          </div>
        </div>
        <div style={{ paddingTop: "0px", paddingLeft: "20px" }}>
          <Table
            rowHeight={100}
            rowsCount={sortedDataList.getSize()}
            width={tableWidth}
            height={containerHeight}
            isColumnResizing={false}
            onColumnResizeEndCallback={this._onColumnResizeEndCallback}
            headerHeight={40}
          >
            <Column
              columnKey="name"
              header={
                <SortHeaderCell
                  onSortChange={this._onSortChange}
                  sortDir={colSortDirs.name}
                >
                  <Icon
                    className="editable"
                    glyph="icon-fontello-arrow-combo"
                  />
                  &nbsp;
                  <AxoLocal entity="Enhedspris5" defaultValue="Navn" />
                </SortHeaderCell>
              }
              cell={(props) => {
                let entry = sortedDataList.getObjectAt(props.rowIndex);
                return (
                  <Cell key={entry.id} {...props}>
                    <div>
                      <InlineEdit
                        value={entry.name || "---"}
                        change={(input) =>
                          this.onChangePropertyValue(
                            entry.id,
                            "name",
                            input.value
                          )
                        }
                      />
                    </div>
                  </Cell>
                );
              }}
              width={columnDefs.name.width}
              isResizable={true}
            />
            <Column
              columnKey="description"
              header={
                <SortHeaderCell
                  onSortChange={this._onSortChange}
                  sortDir={colSortDirs.description}
                >
                  <Icon
                    className="editable"
                    glyph="icon-fontello-arrow-combo"
                  />
                  &nbsp;
                  <AxoLocal entity="Enhedspris6" defaultValue="Beskrivelse" />
                </SortHeaderCell>
              }
              cell={(props) => {
                let entry = sortedDataList.getObjectAt(props.rowIndex);
                return (
                  <Cell key={entry.id} {...props}>
                    <div>
                      <InlineTextArea
                        value={entry.description || "---"}
                        change={(input) =>
                          this.onChangePropertyValue(
                            entry.id,
                            "description",
                            input.value
                          )
                        }
                      />
                    </div>
                  </Cell>
                );
              }}
              width={columnDefs.description.width}
              isResizable={true}
            />
            <Column
              columnKey="picture"
              header={
                <SortHeaderCell
                  onSortChange={this._onSortChange}
                  sortDir={colSortDirs.picture}
                >
                  <Icon
                    className="editable"
                    glyph="icon-fontello-arrow-combo"
                  />
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <AxoLocal entity="Enhedspris2" defaultValue="Billede" />
                </SortHeaderCell>
              }
              cell={(props) => {
                let entry = sortedDataList.getObjectAt(props.rowIndex);
                return (
                  <Cell key={entry.id} {...props}>
                    <div>
                      {!!entry.picture ? (
                        <span>
                          <Icon
                            className="editable"
                            role="button"
                            onClick={() => this.onShowPicture(entry.picture)}
                            glyph="icon-fontello-attach-7"
                          />
                          &nbsp;
                        </span>
                      ) : null}
                      <LexButton onClick={() => this.uploadPicture(entry)}>
                        <AxoLocal
                          entity="DocumentTabViewUpload"
                          defaultValue="Upload"
                        />
                      </LexButton>
                    </div>
                  </Cell>
                );
              }}
              width={columnDefs.picture.width}
              isResizable={true}
            />
            <Column
              columnKey="creationDate"
              header={
                <SortHeaderCell
                  onSortChange={this._onSortChange}
                  sortDir={colSortDirs.creationDate}
                >
                  <Icon
                    className="editable"
                    glyph="icon-fontello-arrow-combo"
                  />
                  &nbsp;
                  <AxoLocal
                    entity="TimeEntryFormntimeEntry"
                    defaultValue="Dato"
                  />
                </SortHeaderCell>
              }
              cell={(props) => {
                let entry = sortedDataList.getObjectAt(props.rowIndex);
                return (
                  <Cell key={entry.id} {...props}>
                    <div>{moment(entry.creationDate).format("L")}</div>
                  </Cell>
                );
              }}
              width={columnDefs.creationDate.width}
              isResizable={true}
            />
            <Column
              columnKey="actions"
              header={<Cell></Cell>}
              cell={(props) => {
                let entry = sortedDataList.getObjectAt(props.rowIndex);
                return (
                  <Cell key={entry.id} {...props}>
                    <Icon
                      role="button"
                      onClick={this.onDeletePrice.bind(this, entry.id)}
                      glyph="icon-fontello-trash-1"
                    />
                  </Cell>
                );
              }}
              width={columnDefs.actions.width}
              isResizable={true}
            />
          </Table>
        </div>
        <FileViewerModal ref={(c) => (this.fileModal = c)} />
        <input
          name="image"
          type="file"
          id="uploadImage"
          accept="image/*"
          style={{ display: "none" }}
        />
      </div>
    );
  }
}

export default withRouter(
  Dimensions({
    getHeight: function (element) {
      return window.innerHeight - 350;
    },
  })(ItemPriceTypesTable)
);
